const TrackMessage = {
  REQUEST_TYPE: 'REQUEST',
  RESPONSE_TYPE: 'RESPONSE',

  GET_USER_INFO: 'GET_USER_INFO',
};

export default TrackMessage;
